import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      const response = await api.post('/auth/forgot-password', {
        email
      });

      if (response.data.success) {
        setSuccess(true);
      } else {
        setError(response.data.message || 'Erro ao solicitar recuperação de senha.');
      }
    } catch (err) {
      if (err.response && err.response.data) {
        setError(err.response.data.message || 'Erro ao processar solicitação.');
      } else {
        setError('Erro de conexão. Verifique se o servidor está rodando.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-body">
      <div className="login-background"></div>

      <div className="login-container-wrapper">
        <h2 className="text-center mb-4" style={{ fontSize: '1.5rem', color: '#1e293b' }}>
          Recuperar Senha
        </h2>

        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}

        {success ? (
          <div className="alert alert-success" role="alert">
            <h5 className="alert-heading">E-mail enviado!</h5>
            <p className="mb-0">
              Se o e-mail existir em nossa base, enviamos um link de recuperação para {email}.
              Verifique sua caixa de entrada e spam.
            </p>
            <div className="mt-3">
              <Link to="/login" className="btn btn-modern btn-modern-primary">
                Voltar para o Login
              </Link>
            </div>
          </div>
        ) : (
          <>
            <p className="text-muted mb-4" style={{ fontSize: '0.9rem' }}>
              Digite seu e-mail abaixo e enviaremos um link para redefinir sua senha.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="form-group-modern">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control-modern"
                  placeholder="Digite seu email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                />
              </div>

              <button
                type="submit"
                className="btn-modern btn-modern-primary w-100 mt-3"
                style={{ padding: '12px', fontSize: '1rem' }}
                disabled={loading}
              >
                {loading ? 'Enviando...' : 'Enviar Link de Recuperação'}
              </button>
            </form>

            <div className="text-center mt-4">
              <Link to="/login" style={{ fontSize: '0.9rem', color: '#64748b' }}>
                Voltar para o Login
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
